































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import DialogConnector from '@/connector/Dialog.vue';
import AuthService from '@/services/AuthService';

const authService = new AuthService();

@Component({
  components: {
    DialogConnector,
  },
})
export default class ResetPasswordDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public oldPassword: string = '';

  public newPassword: string = '';

  public confirmNewPassword: string = '';

  public loading: boolean = false;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  async changePassword() {
    this.loading = true;
    try {
      await authService.changePassword(
        this.oldPassword,
        this.newPassword,
        this.confirmNewPassword,
      );
      this.loading = false;
      this.$store.dispatch('Dialog/updateDialog', { open: false, dialogType: '' });
      this.$store.commit('Snackbar/showNotification', { message: 'เปลี่ยนรหัสผ่านสำเร็จ', error: false });
      this.$store.dispatch('Auth/logout');
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
      this.loading = false;
    }
  }
}
